import { useEffect, useReducer, useState } from 'react';
// import { getFileRemote } from 'src/services/DBService/DbService';
import { getDataUrl } from '../../../../services/MediaFileService/MediaFileService';
import { ImageElement } from '@app/common';
import { useAppSelector } from 'src/store/hooks';

type Properties = {
    data: ImageElement;
    className?: string;
    showErrorMessage?: boolean;
};

type Action = {
    type: 'SET_IMAGE';
    data: string;
};

const reducer = (state: string, action: Action) => {
    if (action.type === 'SET_IMAGE') {
        return action.data;
    }
    return state;
};

const Image = (props: Properties) => {
    const [b64image, dispatch] = useReducer(reducer, '');
    const [isLoading, setIsLoading] = useState(true);
    const studyId = useAppSelector(state => state.globalState.user?.studyId);

    useEffect(() => {
        setIsLoading(true);

        const loadImage = async () => {
            try {
                const dataUrl = await getDataUrl(props.data.id, studyId);
                dispatch({type: 'SET_IMAGE', data: dataUrl});
            } catch (e) {
                console.error('Image ' + props.data.id + ' could not be loaded: ' + e);
            } finally {
                setIsLoading(false);
            }
         };
        loadImage();
    }, [props.data.id]);

    const className = props.className || 'page-image';
    let content: JSX.Element;
    if (isLoading) {
        content = (<p className={className + ' media-loading'}>Bild wird geladen...</p>);
    } else if (!b64image) {
        content = (<p className={className}>{props.showErrorMessage && `Bild ${props.data.id} nicht gefunden.`}</p>);
    } else {
        content = (<p className={className}><img src={b64image} alt={props.data.id} /></p>);
    }

    return (<>{content}</>);
};
export default Image;